module.exports = "https://coursera_assets.s3.amazonaws.com/images/6e5984fc8e54ecc13a7413a1756b2d5f.jpg";